<script>
import baseList from "@/views/components/base/baseList.vue";
// import dayjs from "dayjs";
export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "performanceNew",
        // key: "noticeId",
        url: {
          list: "admin/system/performanceRule/performance/monthlyPage",
        },
        output: false,
      },
      actions: [
        {
          label: "更新",
          icon: "md-sync",
          onClick: this.editSync,
          type: "info",
          auth: "",
        },
      ],
      menus: [],
      query: {},
      filters: [
        {
          label: "时间",
          KeyEnter: this.search,
          name: "searchTime",
          value: "",
          type: "datetimerangemonth",
        },
      ],
      tableCols: [
        // {
        //   title: "序号",
        //   type: "index",
        //   width: 80,
        //   align: "center",
        // },
        {
          title: "姓名",
          key: "userName",
          minWidth: 160,
          align: "center",
        },
        {
          title: "已完成",
          key: "finishedWorkCount",
          width: 150,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.finishedWorkCount;
            return (
              <div
                style="width:100%;font-size:14px;color:#2d8cf0;cursor: pointer;line-height:48px;"
                onClick={() => {
                  this.editInfo(row);
                }}
              >
                <span>{text}</span>
              </div>
            );
            // return h(
            //   "span",
            //   {
            //     style: {
            //       "font-size": "14px",
            //     },
            //   },
            //   text
            // );
          },
        },
        {
          title: "待完成",
          width: 150,
          align: "center",
          key: "unfinishedWorkCount",
          render: (h, params) => {
            const row = params.row;
            const text = row.unfinishedWorkCount;
            return <span>{text}</span>;
          },
        },
        {
          title: "完成比例",
          width: 150,
          align: "center",
          key: "createTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.monthlyTargetRatio;
            return <span>{text}%</span>;
          },
        },
        {
          title: "异常工单",
          width: 150,
          align: "center",
          key: "abnormalWorkCount",
          render: (h, params) => {
            const row = params.row;
            const text = row.abnormalWorkCount;
            return <span>{text}</span>;
          },
        },
        {
          title: "绩效",
          width: 150,
          align: "center",
          key: "actualPerformanceSalary",
          render: (h, params) => {
            const row = params.row;
            const text = row.actualPerformanceSalary;
            return <span>{text}</span>;
          },
        },
        {
          title: "本院排名",
          width: 150,
          align: "center",
          key: "hospitalRanking",
          render: (h, params) => {
            const row = params.row;
            const text = row.hospitalRanking;
            return <span>{text}</span>;
          },
        },
        {
          title: "全部排名",
          width: 150,
          align: "center",
          key: "companyRanking",
          render: (h, params) => {
            const row = params.row;
            const text = row.companyRanking;
            return <span>{text}</span>;
          },
        },
        // {
        //   title: "操作",
        //   align: "center",
        //   width: 160,
        //   key: "handle",
        //   handle: ["edit", "delete"],
        // },
      ],
    };
  },
  created() {
    // this.query.searchTime = dayjs().format("YYYY-MM");
  },
  methods: {
    async editSync() {
      let q = {};
      let res = await $utils.api.load(
        "admin/system/performanceRule/performance/refreshCache",
        q,
        "POST"
      );
      if (res.code == 200) {
        console.log(res);
        $utils.toast.success(res.msg);
        this.search();
      }
    },
    editInfo(row) {
      console.log(row);

      $utils.url.push({
        name: "performance_new_detailList",
        query: { kv: row.userId, searchTime: this.query.searchTime },
      });
    },
  },
};
</script>
